import { PABaseUtility } from "./pa-base.utility";
import { PAMenuDesktop, PAMenuMobile, PASection } from "./pa-menu-meta";
import { PASectionUtility } from "./pa-section.utility";

export class PAMenuUtility extends PABaseUtility {

  /* 
  -- Desktop Left Menu
  -- Desktop Small Screen (Tablet) Hidden Left Menu
  -- Desktop Small Screen (Tablet) Hidden Top Menu
  */
  public static buildMenuDesktop(): PAMenuDesktop {

    let sections: Map<string, PASection> = new Map();
    let index = 0;
    sections.set('account', PASectionUtility.buildSectionAccount(index++));
    sections.set('internalTransfer', PASectionUtility.buildSectionInternalTransfers(index++));
    sections.set('externalTransfer', PASectionUtility.buildSectionExternalTransfers(index++));
    sections.set('payments', PASectionUtility.buildSectionPayments(index++));
    sections.set('payroll', PASectionUtility.buildSectionPayroll(index++));
    sections.set('orders', PASectionUtility.buildSectionOrders(index++));
    sections.set('services', PASectionUtility.buildSectionServices(index++));
    sections.set('settings', PASectionUtility.buildSectionSettings(index++));
    sections.set('externalLinks', PASectionUtility.buildSectionExternalLinks(index++));
    sections.set('corp', PASectionUtility.buildSectionCorp(index++));

    return new PAMenuDesktop('menuDesktop').setSections(PABaseUtility.filterSections(sections));
  }

  /* Desktop Top Menu */
  public static buildMenuDesktopTop(): PAMenuDesktop {

    let sections: Map<string, PASection> = new Map();
    let index = 0;
    sections.set('account', PASectionUtility.buildSectionAccount(index++));
    sections.set('transfers', PASectionUtility.buildSectionTransfers(index++));
    sections.set('payments', PASectionUtility.buildSectionPayments(index++));
    sections.set('payroll', PASectionUtility.buildSectionPayroll(index++));
    sections.set('orders', PASectionUtility.buildSectionOrders(index++));
    sections.set('services', PASectionUtility.buildSectionServices(index++));
    sections.set('settings', PASectionUtility.buildSectionSettings(index++));
    sections.set('externalLinks', PASectionUtility.buildSectionExternalLinks(index++));

    return new PAMenuDesktop('menuDesktopTop').setSections(PABaseUtility.filterSections(sections));
  }

  /* Mobile View */
  public static buildMenuMobileView(): PAMenuMobile {
    let menu: PAMenuMobile = new PAMenuMobile('menuMobileView');
    let index = 0;
    menu.setSector(PASectionUtility.buildSector_A_Desktop(index++));
    menu.setSector(PASectionUtility.buildSector_B_Desktop(index++));
    return menu;
  }

  /* Mobile App */
  public static buildMenuMobileApp(): PAMenuMobile {
    let menu: PAMenuMobile = new PAMenuMobile('menuMobileApp');
    let index = 0;
    menu.setSector(PASectionUtility.buildSector_A_Mobile(index++));
    menu.setSector(PASectionUtility.buildSector_B_Mobile(index++));
    return menu;
  }
}